import React from "react";
import {
  FullScreenWrapper,
  LeftSection,
  RightSection,
  StepsContainer,
  StepItem,
  StepCircle,
  StepContent,
  StepTitle,
  StepDescription,
  StepLine,
} from "./styled";
import { useNavigate } from "react-router-dom";
import { Grid } from "@mui/material";
import Header from "../../components/common/Header";
import Footer from "../../components/common/Footer";
import LogInColaboratorForm from "./Forms/log-in-colaborator";

export default function EntryHome() {
  const navigate = useNavigate();

  const steps = [
    {
      number: 1,
      title: "Paso #1",
      description: "Regístrate con tus datos para empezar a participar.",
    },
    {
      number: 2,
      title: "Paso #2",
      description:
        "Se te asignarán retos que debes cumplir realizando tus transacciones favoritas.",
    },
    {
      number: 3,
      title: "Paso #3",
      description: "¡Cumple todos tus retos y gana premios al instante!",
    },
  ];

  return (
    <FullScreenWrapper>
      <Header />

      <Grid
        container
        sx={{
          minHeight: "calc(100vh - 100px)",
          flexDirection: { xs: "column-reverse", md: "row" },
        }}
      >
        {/* Sección izquierda */}
        <Grid item xs={12} md={7}>
          <LeftSection>
            <StepsContainer>
              {steps.map((step, index) => (
                <StepItem key={step.number}>
                  <StepCircle>{step.number}</StepCircle>
                  <StepContent>
                    <StepTitle>{step.title}</StepTitle>
                    <StepDescription>{step.description}</StepDescription>
                  </StepContent>
                  {index === 0 && <StepLine />}
                </StepItem>
              ))}
            </StepsContainer>
          </LeftSection>
        </Grid>

        {/* Sección derecha */}
        <Grid item xs={12} md={5}>
          <RightSection>
            <LogInColaboratorForm />
          </RightSection>
        </Grid>
      </Grid>

      <Footer />
    </FullScreenWrapper>
  );
}
